import api from './api';

export default {
  getJourneyTypes() {
    return new Promise((resolve, reject) => {
      api
        .get('journey-type', {
          params: {
            includes: [
              'journeys.criteria.question',
              'journeys.questionGroups.questions.answers',
              'journeys.questionGroups.questions.questionType',
              'journeys.questionGroups.questions.parents'
            ].join(','),
            orderby: 'sort_order,asc'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
